import React from 'react';
import { CheckCircle2, MoreHorizontal, Search, Bell, ChevronDown, Calendar, Clock } from 'lucide-react';

export const HeroMock: React.FC = () => {
  return (
    <div className="relative w-full max-w-lg mx-auto lg:max-w-none">
      {/* Main App Window */}
      <div className="relative bg-white rounded-xl border border-border shadow-2xl overflow-hidden aspect-[4/3] lg:aspect-[16/11]">
        
        {/* Topbar */}
        <div className="h-12 border-b border-subtle flex items-center justify-between px-4 bg-white/50 backdrop-blur-sm sticky top-0 z-10">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-red-400"></div>
            <div className="w-3 h-3 rounded-full bg-amber-400"></div>
            <div className="w-3 h-3 rounded-full bg-green-400"></div>
          </div>
          <div className="flex items-center gap-4 text-muted">
             <div className="flex items-center gap-2 px-2 py-1 bg-subtle rounded-md text-xs w-48">
               <Search size={12} />
               <span>Buscar brief...</span>
             </div>
          </div>
          <div className="flex items-center gap-3 text-muted">
            <Bell size={14} />
            <div className="w-6 h-6 rounded-full bg-ink text-white flex items-center justify-center text-xs font-bold">JD</div>
          </div>
        </div>

        {/* Layout: Sidebar + Main */}
        <div className="flex h-full">
          {/* Sidebar */}
          <div className="w-48 bg-subtle/50 border-r border-subtle hidden sm:flex flex-col p-3 gap-1">
            <div className="px-2 py-1.5 text-xs font-semibold text-muted uppercase tracking-wider mb-2">Workspace</div>
            <div className="px-3 py-2 bg-white rounded-md border border-border shadow-sm text-sm font-medium text-ink flex items-center justify-between">
              <span>Inbox</span>
              <span className="bg-primary text-white text-[10px] px-1.5 rounded-full">3</span>
            </div>
            <div className="px-3 py-2 text-sm text-muted hover:bg-white/50 rounded-md">Meus Briefs</div>
            <div className="px-3 py-2 text-sm text-muted hover:bg-white/50 rounded-md">Equipe</div>
            <div className="mt-auto px-3 py-2 text-xs text-muted border-t border-border pt-4">
              PERO Brief v1.0
            </div>
          </div>

          {/* Main Content (Inbox) */}
          <div className="flex-1 p-6 bg-white overflow-hidden relative">
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display font-bold text-xl text-ink">Inbox de Hoje</h3>
              <div className="flex items-center gap-2 text-sm text-muted bg-subtle px-3 py-1.5 rounded-lg border border-border">
                <Calendar size={14} />
                <span>Hoje</span>
                <ChevronDown size={12} />
              </div>
            </div>

            {/* List Items */}
            <div className="space-y-3">
              {[
                { title: "Aprovação Budget Marketing Q3", tag: "Financeiro", color: "text-amber-600 bg-amber-50 border-amber-100", time: "10:30" },
                { title: "Revisão de Metas Comerciais", tag: "Estratégia", color: "text-blue-600 bg-blue-50 border-blue-100", time: "14:00" },
                { title: "Feedback Design System", tag: "Produto", color: "text-purple-600 bg-purple-50 border-purple-100", time: "16:45" },
                { title: "Alinhamento Mensal Sócios", tag: "Diretoria", color: "text-slate-600 bg-slate-100 border-slate-200", time: "17:00" },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-3 rounded-lg border border-subtle hover:border-border transition-colors group cursor-default">
                  <div className="w-5 h-5 rounded border border-muted/30 flex items-center justify-center text-white group-hover:border-primary group-hover:text-primary transition-colors">
                    <CheckCircle2 size={14} className="opacity-0 group-hover:opacity-100" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-ink truncate">{item.title}</div>
                    <div className="flex items-center gap-2 mt-1">
                       <span className={`text-[10px] px-1.5 py-0.5 rounded border ${item.color}`}>{item.tag}</span>
                       <span className="text-[10px] text-muted flex items-center gap-1"><Clock size={10} /> {item.time}</span>
                    </div>
                  </div>
                  <MoreHorizontal size={14} className="text-muted opacity-0 group-hover:opacity-100" />
                </div>
              ))}
            </div>

            {/* Gradient Fade at bottom */}
            <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>

      {/* Floating Elements (Overlays) */}
      
      {/* 1. Success Card */}
      <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl border border-border p-4 w-64 animate-[float_6s_ease-in-out_infinite] z-20 hidden md:block">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center shrink-0">
            <CheckCircle2 size={14} strokeWidth={3} />
          </div>
          <div className="flex-1">
            <h4 className="text-sm font-bold text-ink">Brief Gerado</h4>
            <p className="text-xs text-muted mt-1 leading-snug">
              Resumo da reunião enviado para 4 participantes.
            </p>
            <div className="mt-3 h-1.5 w-full bg-subtle rounded-full overflow-hidden">
              <div className="h-full bg-green-500 w-full rounded-full"></div>
            </div>
            <div className="mt-1 flex justify-between text-[10px] text-muted font-medium">
              <span>Status</span>
              <span className="text-green-600">Enviado</span>
            </div>
          </div>
        </div>
      </div>

      {/* 2. Urgent Action Card */}
      <div className="absolute top-12 -right-12 bg-white rounded-xl shadow-lg border border-border p-4 w-48 z-20 hidden lg:block transform rotate-2 hover:rotate-0 transition-transform duration-300">
         <div className="flex items-center justify-between mb-2">
            <div className="text-[10px] font-bold text-amber-600 bg-amber-50 px-2 py-0.5 rounded-full border border-amber-100">
              Ação Requerida
            </div>
         </div>
         <p className="text-xs font-medium text-ink mb-2">
           Aprovar orçamento Q3 até 18:00
         </p>
         <div className="flex -space-x-2">
           <div className="w-6 h-6 rounded-full border-2 border-white bg-slate-200"></div>
           <div className="w-6 h-6 rounded-full border-2 border-white bg-slate-300"></div>
         </div>
      </div>

    </div>
  );
};